<div class="container">
  <div class="dropdown" (mouseleave)="toggleClose()">
    <button class="dropbtn dropdown-toggle" (click)="toggleOpen()">
      <span>{{ title }}</span>
    </button>
    <div [ngClass]="{ 'dropdown-content': true, opened: open }">
      <ng-content></ng-content>
    </div>
  </div>
</div>
